import React, { useEffect, useState } from 'react';
import '../../scss/table_view.scss';
import { useSelector } from 'react-redux';
import edit from '../../images/common/edit.png';
import trash from '../../images/common/trash.png';
import editDark from '../../images/common/edit-dark.png';
import trashDark from '../../images/common/trash-dark.png';
import placeholder from '../../images/common/logo-placeholder.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';

function TableView({getDetails, handleShow, setDelete, page, callSortApi, sortValues}) {
    const dataListValues = useSelector((state) => state.dataListValues);
    const tableHeaders = useSelector((state) => state.headerListValues);
    const userRole = useSelector((state) => state.role);

    const addDarkImage = (e, index) => {
        if(page == "Entities" || (page != "Entities" && userRole == 1)) {
            const editElement = document.getElementById('edit'+index)
            const trashElement = document.getElementById('trash'+index)
            editElement.src = editDark;
            trashElement.src = trashDark;
        }
    }

    const removeDarkImage = (e, index) => {
        if(page == "Entities" || (page != "Entities" && userRole == 1)) {
            const editElement = document.getElementById('edit'+index)
            const trashElement = document.getElementById('trash'+index)
            editElement.src = edit;
            trashElement.src = trash;
        }
    }

    const handlEdit = (event, brandId) => {
        event.stopPropagation();
        getDetails(brandId, 'edit');
    }

    const handleDelete = (event, id) => {
        event.stopPropagation();
        handleShow();
        setDelete(id)
    }

    const handleOverview = (id) => {
        getDetails(id, 'overview');
    }

    return (
        <>
            <div className='table-view-container'>
                <div className='list-items' id="print">
                    <table>
                        <thead>
                            <tr className='heading-row'>
                                {tableHeaders.map(item => {
                                    return (
                                        <>  
                                            {(item.name == "") ? 
                                            (<th className="heading-data logo-header" style={{ minWidth: `${item.width}`, textAlign: "left" }}>
                                                <div className='flex-display'>
                                                    <div className='label'>{item.name}</div>
                                                    {item.sort &&
                                                    (<div className='sort-arrows'>
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" 
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='asc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'desc') &&
                                                            <img className='downarrow' src={downsort} alt="downarrow"
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='desc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                    </div>)}  
                                                </div>                                  
                                            </th>) :
                                            (item.name === "Actions" ? 
                                            ((page == "Entities" || (page != "Entities" && userRole == 1)) &&
                                            <th className="heading-data action-heading" style={{ minWidth: `${item.width}`, textAlign: "left" }}>
                                                <div className='flex-display'>
                                                    <div className='label'>{item.name}</div>
                                                    {item.sort &&
                                                    (<div className='sort-arrows'>
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" 
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='asc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'desc') &&
                                                            <img className='downarrow' src={downsort} alt="downarrow"
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='desc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                    </div>)}  
                                                </div>                                  
                                            </th>) : 
                                            ((<th className="heading-data" style={{ minWidth: `${item.width}`, textAlign: "left" }}>
                                                <div className='flex-display'>
                                                    <div className='label'>{item.name}</div>
                                                    {item.sort &&
                                                    (<div className='sort-arrows'>
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'asc') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" 
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='asc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'desc') &&
                                                            <img className='downarrow' src={downsort} alt="downarrow"
                                                            data-sort-by={(item.name).toLowerCase()} data-sort-type='desc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                        }
                                                    </div>)}  
                                                </div>                                  
                                            </th>))
                                            )}
                                        </>
                                    )
                                })}
                            </tr>
                        </thead>
                        {
                            dataListValues && dataListValues.length === 0 ? (<p className="no-result">No results found</p>) :
                            <tbody className='table-body'>
                                {dataListValues != null && dataListValues.map((item, index) => {
                                    return (
                                        <tr id={index} onMouseOver={(e) => addDarkImage(e, index)} onMouseLeave={(e) => removeDarkImage(e, index)} 
                                        onClick={() => page == "Entities" ? handleOverview(item.idEntities) : handleOverview(item.idBrand)}>
                                            <td className='data1 logo'><div><div className='logo-bg' style={{backgroundImage: `url(${item.logoUrl.includes('\\') ? item.logoUrl.replaceAll('\\', '/') : item.logoUrl})`}} alt="Logo"/></div></td>
                                            <td className='data2'>{item.name}</td>
                                            {page == "Entities" && <td className='data2'>{item.propertyCode}</td>}
                                            {page == "Entities" && <td className='data7'>{item.brand != null && item.brand.name}</td>}
                                            {/* <td className='data3'>{item.email}</td>
                                            <td className='data4'>{item.phoneNumber}</td> */}
                                            <td className='data5 mailing-address'>{item.address}</td>
                                            {(page == "Entities" || (page != "Entities" && userRole == 1)) &&
                                            <td className='data6 action'>
                                                <img id={`${'edit'+index}`} className='edit' src={edit} alt="edit" onClick={(e) => ((page == "Entities") ? handlEdit(e, item.idEntities) : handlEdit(e, item.idBrand))}></img>
                                                <img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" onClick={(e) => (page == "Entities" ? handleDelete(e, item.idEntities) : handleDelete(e, item.idBrand))}></img>
                                            </td>}
                                        </tr>
                                    )
                                })}
                                
                            </tbody>
                        }
                    </table>
                </div>
            </div>
        </>
    )
}

export default TableView;